export enum BOOKING_ROOM_STATUS {
    ACTIVE = "ACTIVE",
    DRAFT = "DRAFT"
}

export enum BOOKING_ROOM_DATE_TYPE {
    SINGLE_DAY = 'เฉพาะวัน', // i18n-ignore: persisted enum value, translated at render site with t(value)
    RANGE = 'เฉพาะช่วงวันที่', // i18n-ignore: persisted enum value, translated at render site with t(value)
}

export enum DAY_OF_WEEKS {
    MONDAY = 'จันทร์', // i18n-ignore: persisted enum value, translated at render site with t(value)
    TUESDAY = 'อังคาร', // i18n-ignore: persisted enum value, translated at render site with t(value)
    WEDNESDAY = 'พุธ', // i18n-ignore: persisted enum value, translated at render site with t(value)
    THURSDAY = 'พฤหัสบดี', // i18n-ignore: persisted enum value, translated at render site with t(value)
    FRIDAY = 'ศุกร์', // i18n-ignore: persisted enum value, translated at render site with t(value)
    SATURDAY = 'เสาร์', // i18n-ignore: persisted enum value, translated at render site with t(value)
    SUNDAY = 'อาทิตย์', // i18n-ignore: persisted enum value, translated at render site with t(value)
}

export const day_of_weeks_data = Object.values(DAY_OF_WEEKS)